import React from "react";
import { Link } from "react-router-dom";
import { Flex } from "./Flex";
import { ArrowBackIcon } from "../icons/ArrowBackIcon";


const Breadcrumbs = ({ items=[] }) => {
    let breadcrumbs = [];
    items.map((item, i) => {
        if (item) {
            if (i > 0) {
                breadcrumbs.push(<ArrowBackIcon key={`breadcrumb-arrow-${i}`} color="var(--sp-label-color)" />);
            }
            if (item.href && i < items.length-1) {
                breadcrumbs.push(<Link key={`breadcrumb-${i}`} to={item.href}>{item.title}</Link>);
            } else {
                breadcrumbs.push(item.title);
            }
        }
    });
    return <Flex align="center">
        {breadcrumbs}
    </Flex>
};

export { Breadcrumbs };